import * as React from 'react'
import styled, { keyframes } from 'styled-components'

export type InProgressIconSize = 'small' | 'large'

// ----------------------------------------------------------------------------

export class InProgressIcon extends React.PureComponent<{ color: string; size: number; variant?: 'dot' }> {
  render() {
    const { color, size } = this.props

    const { width, height } = (() => ({ width: size, height: (size * 2) / 3 }))()

    return (
      <div title="Real Time">
        <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
          <LoadingDots color={color} width={width} height={height} />
        </svg>
      </div>
    )
  }
}
const loadAnimation = keyframes`
    from {
      opacity:0;
    }
    to {
      opacity:1;
    }
`

const DotGroup = styled.g`
  fill: var(--gray-color);
  #dot1 {
    animation: ${loadAnimation} 1s infinite;
  }

  #dot2 {
    animation: ${loadAnimation} 1s infinite;
    animation-delay: 0.2s;
  }

  #dot3 {
    animation: ${loadAnimation} 1s infinite;
    animation-delay: 0.4s;
  }
`

const LoadingDots = ({ width, height }: { color: string; width: number; height: number }) => {
  const r = (width / 19) * 2.5
  const gap = (width / 19) * 2
  return (
    <DotGroup>
      <circle id="dot1" cx={r} cy={height / 2} r={r}></circle>
      <circle id="dot2" cx={2 * r + gap + r} cy={height / 2} r={r}></circle>
      <circle id="dot3" cx={2 * r + gap + 2 * 2 + gap + r} cy={height / 2} r={r}></circle>
    </DotGroup>
  )
}
